import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import BuyerCards from "components/BuyerCards";

import { saleIdOnly } from "lib/sale";

import {
  getSaleLotGroupsByThirdPartyBuyerAndBuyerWay,
  getSaleLotGroupsByThirdPartyBuyerAndBuyerWayByRound,
} from "selectors";

const mapStateToProps = (state, props) => ({
  thirdParties: getSaleLotGroupsByThirdPartyBuyerAndBuyerWay(
    state,
    saleIdOnly(props),
  ),
  thirdPartiesByRound: getSaleLotGroupsByThirdPartyBuyerAndBuyerWayByRound(
    state,
    saleIdOnly(props),
  ),
  basePath: props.match.url,
});

export default compose(connect(mapStateToProps), withRouter)(BuyerCards);
